<template lang="pug">
	.progress-bar
		.progress(:style="`width: ${percent}%;`")

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.progress-bar
		margin: 15px 0
		background: sfc-pale-blue
		height: 4px
		display: block
		overflow: hidden
		width: 100%
		.progress
			border-radius: 0px
			height: 4px
			transition-all-four()
			border-right-raius: 3px
			background: sfc-royal-blue
			top: 0px
			position: relative

</style>

<script>

export default {
	props: {
		percent:{
			default: 0
		}
	}
}
</script>
